import { COLORS } from '../pages/userProfile/components/userGroupsField/userGroupFieldStyle';

/*eslint-disable*/
export const noop = () => {};

export const generateUniqueId = () => {
  // Generate a timestamp
  const timestamp = new Date().getTime();
  // Generate a random number (convert to string to remove decimal point)
  const random = Math.random().toString().split(".")[1];
  // Combine timestamp and random number to create the unique ID
  const uniqueId = `${timestamp}${random}`;
  return uniqueId;
};

export const sortByProperty = (arr=[], property) => {
  return arr.sort((a, b) => {
    // Use localeCompare for string comparison
    return a[property].localeCompare(b[property]);
  });
};

export const areObjectsEqual = (obj1, obj2) => {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    if (obj1[key] !== obj2[key]) {
      return false;
    }
  }

  return true;
}

// resuable function to determine color for groups
export function ColorCodeGroups(appGroups) {
    const colors = {}
    appGroups.forEach((group, idx) => {
        colors[group] = COLORS[idx % COLORS.length]
    })
    return colors
}
